import React from "react";
import { useParams } from "react-router-dom";
import PrimaryNav from "../../components/PrimaryNav/PrimaryNav";
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import SidebarNav from "../../components/SidebarNav/SidebarNav";
import { ROUTES } from "../../helpers/menus/routeConstants";
import { menuItems } from "../../helpers/menus/docsSidebarMenuItems";
import "swagger-ui-react/swagger-ui.css";
import SwaggerLoader from "./SwaggerLoader";
import { filterDocsSidebar } from '../../helpers/menus/filterDocsSidebar'; 
import { apiNames } from '../../helpers/menus/apiNames';

const SwaggerView = () => {
  const { slug, apiname } = useParams();

  let breadcrumbs = [
    { name: "Home", link: "/" },
    { name: "API Library", link: ROUTES["API Library"] },
    { name: apiNames[slug], link: `#` }
  ];

  const filteredMenuItems = filterDocsSidebar(menuItems, slug);

  return (
    <>
      <PrimaryNav />
      <Breadcrumbs crumbs={breadcrumbs} />
      <div className="grid-row grid-gap padding-x-5">
        <SidebarNav menuItems={filteredMenuItems} />
        <div className="tablet:grid-col-6 markdown">
          <SwaggerLoader appId={apiname}/>
        </div>
      </div>
    </>
  );
};

export default SwaggerView;
